function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#a1dbd3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2019",
  d: "M10.902 4.714H7.075v5.65l1.941-1.94a.589.589 0 01.833.833l-2.947 2.947a.589.589 0 01-.833 0l-2.95-2.948a.589.589 0 01.833-.833l1.941 1.94V4.714h-3.83A2.065 2.065 0 000 6.777v7.661a2.065 2.065 0 002.063 2.063h8.84a2.065 2.065 0 002.063-2.063V6.777a2.065 2.065 0 00-2.064-2.063z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2020",
  d: "M7.072.589a.59.59 0 00-1.179 0v4.125h1.179z"
}));
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.965,
    height: 16.501
  }, props), _ref);
};
export default SvgDownload;